$(document).ready(function () {
    var mySwiper = new Swiper(".logo_main_section_wrap .swiper-container", {
        spaceBetween: 0,
        centeredSlides: !0,
        speed: 6000,
        autoplay: { delay: 1 },
        loop: !0,
        slidesPerView: "auto",
        allowTouchMove: !1,
        disableOnInteraction: !0,
    });
    var mySwiper = new Swiper(".custom-new-grid.custom_slider-collection .swiper-container", {
        freeMode: !0,
        slidesPerView: 4,
        spaceBetween: 12,
        pagination: { el: ".slider__pagination", clickable: !0 },
        navigation: { nextEl: ".slider__button-next", prevEl: ".slider__button-prev" },
        breakpoints: {
            768: { slidesPerView: 4, spaceBetween: 12 },
            481: { slidesPerView: 2, freeMode: !1, spaceBetween: 12 },
            320: { slidesPerView: 1, freeMode: !1, loop: !0, spaceBetween: 12 },
        },
    });
    $(document).on("click", ".custom_contact_form .custom_contact_tab p.custom_contact_tabIn", function () {
        $(".custom_contact_form .custom_contact_tab p.custom_contact_tabIn").removeClass("active");
        $(this).addClass("active");
        var data_handle = $(this).attr("data-handle");
        $(".custom_contact_form .tab_data_main").hide();
        $(".custom_contact_form .tab_data_main[data-handle='" + data_handle + "']").show();
    });
    var mySwiper = new Swiper(".custom_slideshow-wrapper .swiper-container", {
        freeMode: !0,
        slidesPerView: 4.5,
        spaceBetween: 32,
        scrollbar: { el: ".swiper-scrollbar", draggable: !0, snapOnRelease: !1 },
        breakpoints: {
            1025: { slidesPerView: 4.5, spaceBetween: 32 },
            768: { slidesPerView: 3.5, spaceBetween: 20 },
            320: { slidesPerView: 1.2, spaceBetween: 12 },
        },
    });
    // $(".custom_calculator_wrapp .product_btn_bottom a.btn.js-no-transition").click(function (e) {
    //     e.preventDefault();
    //     var selected_val = $(".all_collection_data").find("select option:selected").val();
    //     var selected_val2 = $(".product_types_wrapp").find("select option:selected").val();
    //     var selected_val3 = $(".product_price_wrapp").find("input").val();
    //     window.location.href =
    //         "/collections/" +
    //         selected_val +
    //         "-" +
    //         selected_val2 +
    //         "?filter.v.price.gte=0.00&filter.v.price.lte=" +
    //         selected_val3 +
    //         ".00";
    // });

    $(".custom_calculator_wrapp .product_btn_bottom a.btn.js-no-transition").click(function (e) {
    e.preventDefault();

    var selected_val = $(".all_collection_data select option:selected").val();
    var selected_val2 = $(".product_types_wrapp select option:selected").val();

    // get input value
    var selected_val3 = $("#priceidd").val();

    // fallback default
    if (selected_val3 == "" || selected_val3 == null) {
        selected_val3 = 10000;
    }

    window.location.href =
        "/collections/" +
        selected_val +
        "-" +
        selected_val2 +
        "?filter.v.price.gte=0.00&filter.v.price.lte=" +
        selected_val3 +
        ".00";
});
    $(".label-input-cross-wrapp input.input-full").each(function () {
        if ($(this).val().length == 0) {
            $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
        } else {
            $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
        }
    });
    $(".label-input-cross-wrapp input.input-full").focus(function () {
        $(".label-input-cross-wrapp input.input-full").each(function () {
            if ($(this).val().length == 0) {
                $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
            }
        });
        $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
    });
    $(".label-input-cross-wrapp label.form-label").click(function () {
        $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
        $(this).parents(".label-input-cross-wrapp").find("input").focus();
    });
    $(".label-input-cross-wrapp .cross_input").click(function () {
        $(this).parents(".label-input-cross-wrapp").find("input").val("");
        $(this).parents(".label-input-cross-wrapp").find("input").blur();
    });
    $(".label-input-cross-wrapp input.input-full").blur(function () {
        $(".label-input-cross-wrapp input.input-full").each(function () {
            if ($(this).val().length == 0) {
                $(this).parents(".label-input-cross-wrapp").removeClass("input_focused");
            } else {
                $(this).parents(".label-input-cross-wrapp").addClass("input_focused");
            }
        });
    });
    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    function delete_cookie(name) {
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
    var appointmentform = getCookie("appointmentform");
    if (appointmentform.indexOf("appointmentform") > -1) {
        var header_height = $("div#HeaderWrapper").height();
        $("html, body").animate({ scrollTop: $(".custom-map-form-sec").offset().top - header_height }, 2000);
        delete_cookie("appointmentform");
    }
    $(".homepage_header").click(function (e) {
        e.preventDefault();
        var header_height = $("div#HeaderWrapper").height();
        $("html, body").animate({ scrollTop: $(".custom-map-form-sec").offset().top - header_height }, 2000);
    });
});
